import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';
import { CostAnalysisirs1099Detail } from './costanalysisirs1099details';

@Injectable()
export class CostAnalysisIrs1099Service {
    private _Cost1099ServiceReportUrl = CONFIGURATION.baseServiceUrl + 'irs1099servicereport/';
    constructor(private _http: Http) { }

    getTaxYear(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._Cost1099ServiceReportUrl + 'getTaxYear', { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getProductionandCompany(taxYear: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._Cost1099ServiceReportUrl + 'getProductionAndCompanyByTaxYear?TaxYear=' + taxYear,
            { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    get1099Report(filterCriteria: any): Observable<CostAnalysisirs1099Detail[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        const fileName = 'getIRS1099ReportData?TaxYear=' + filterCriteria.selectedYear
            + '&Proudctioncompany=' + filterCriteria.selectedProductionShow + '&CompanyName=' + filterCriteria.selectedCompany;
        return this._http.get(this._Cost1099ServiceReportUrl + fileName, { headers: headers })
            .map((response: Response) => <CostAnalysisirs1099Detail[]>response.json())
            .catch(this.handleError);
    }

    downloadExcelReport(filterCriteria: any): any {
        const fileName = 'excel-download?TaxYear=' + filterCriteria.selectedYear
            + '&Proudctioncompany=' + filterCriteria.selectedProductionShow + '&CompanyName=' + filterCriteria.selectedCompany;
        const url = this._Cost1099ServiceReportUrl + fileName
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(url, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })

    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }

    getReportData(data: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._Cost1099ServiceReportUrl + `v2/getIRS1099ReportData`,data, { headers: headers })
          .map((res: Response) => res.json())
      }
      getVendorData(data: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._Cost1099ServiceReportUrl + `v2/getvendordetails`,data, { headers: headers })
          .map((res: Response) => res.json())
      }

}



// WEBPACK FOOTER //
// ./src/app/costanalysisirs1099/costanalysisirs1099.service.ts